import {HostListener, Directive} from '@angular/core';

@Directive({
  selector: '[ngbdScrolling]'
})
export class NgbdScrolling {
  private shrinkHeader: number;

  constructor() {
    this.shrinkHeader = 64;
  }


  // @HostListener('window:scroll') onScroll() {

  @HostListener('window:scroll', ['$event'])
    public onScroll(event) {
    // $(window).scroll(function () {
    const scroll = this.getCurrentScroll();
    if (scroll >= this.shrinkHeader
      && ( document.getElementsByTagName('clo-tab-navigation').length
        || document.getElementsByTagName('clo-mobile-nav').length
      )
    ) {
      document.body.classList.add('scrolled');
    } else {
      document.body.classList.remove('scrolled');
    }
  }

  private getCurrentScroll() {
    return window.pageYOffset || document.documentElement.scrollTop;
  }

}
